import React, { useEffect, useState,useRef } from "react";
import ImmediateSessionDot from "../ImmediateSessionDot";
// import moment from "moment";
import { filterList } from "../data";
import { useSelector } from "react-redux";
import Select from "react-select";
import { useNavigate, useSearchParams } from "react-router-dom";
import Search from "../../../../components/search";
// import Button from "../../../../components/button";
import { screenNameHandler, session_id_beg, session_id_end } from "../../../../utils/helpers";
import Sorting from "../../../../components/sorting";
import Pagination from "../../../../components/tablePagination";

import { fireFilter } from "../functions";
import ConfirmCancelNotePopup from "../subcomponents/confirmcancelpopup";
import CsvDownload from "../../../../components/csvdownload";
import CopyComponent from "../../../../components/copyComponent";
import ReasonCancel from "../subcomponents/reasonpopup";
import Button from "../../../../components/button";
import RefundDeleteModal from "../../../../components/refundConfirmModal";
import { getAllCancellationReasons } from "../../../../services/medium";
import {
  cancelGroupAppointments,
  confirmAppointmentstatus,
  getAllClients,
  getAllMediums,
  getAdminRescheduleSlots,
  getCreateAppointmentSubseesions,
  noshowGroupAppointments,
  noshowRemoveGroupAppointments,
  regenerateZoomLink,
  resendZoomLink,
  ExportData
} from "../../../../services/admin";
import { toast } from "react-toastify";
import { showRefundNotice } from "../../../../utils/refundNotice";
import ConfirmCancel from "../subcomponents/cancelpopup";
import { emptyAllSelectBox, filterVisibleTimeZones } from "../../../../utils/helpers";
import CreateNewAppointment from "../../Subcomponents/createappointment";
import CreateNewMediumAppointment from "../../Subcomponents/createmediumappointment";
import Toggle from "../subcomponents/toggle";
import ConfirmDeleteModal from "../../../../components/deleteConfirmModal";
import AppointmentConfirmModal from "../../../../components/appointmentsConfirmModal";
import ReScheduleAppointment from "../../Subcomponents/rescheduleappt";
import moment from "moment";
import Filter from "../../../../components/filter";
import NoshowBox from "../subcomponents/noshowbox";
import WorkerBox from "../subcomponents/workersbox";
import { useDispatch } from "react-redux";
import ToggleTestUser from "../../Subcomponents/toogletestuser";

import { setLoading, setLoadingContent, setLoadingText } from "../../../../reducer/auth/auth";
import { refundingAppointment, stopPaymentAppointment } from "../../../../services/medium";
import AppointmentInfoPanel from "../AppointmentInfoPanel";

var apptAvatarPalettes = [
  { background: '#f5e6d8', color: '#b87040' },
  { background: '#faf0e8', color: '#c07838' },
  { background: '#eeddd0', color: '#a86030' },
  { background: '#f7ece0', color: '#d5a67b' },
  { background: '#f0e0cc', color: '#b87848' },
];
function apptGetInitials(name) {
  if (!name) return '?';
  var parts = name.trim().split(' ').filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.substring(0, 2).toUpperCase();
}
function apptGetAvatarStyle(name) {
  var idx = name ? name.charCodeAt(0) % apptAvatarPalettes.length : 0;
  return Object.assign({}, apptAvatarPalettes[idx], {
    width: 36, height: 36, borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontWeight: '700', fontSize: '13px', flexShrink: 0,
  });
}

const headers = [
  { label: "Medium Name", key: "medium_name" },
  { label: "Client Name", key: "client_name" },
  { label: "Date", key: "date" },
  { label: "Time", key: "time" },
  { label: "Session Name", key: "session_type" },
  { label: "Medium Email", key: "medium_emails" },
  { label: "Client Email", key: "client_emails" },

  { label: "Meeting Link", key: "meeting_link" },
  // { label: 'Feedback Links', key: "" },
  // { label: 'Date and Time Cancelled', key: 'date_time_canceled' },
  // { label: "Cancelled By", key: 'userby' },
  // { label: "No Show By", key: 'userby' },
];
export default function Upcoming(props) {
  const {
    upcomingAppointments,
    setUpcomingAppointments,
    changeHandler,
    filterListAppointments,
    filterReset,
    getPaginationData,
    setFilterValues,
    setSearchValues,
    getAllAppointmentsList,
    activeTab,
    upcomingAppointmentsPage,
    upcomingAppointmentsrowsPerPage,
    searchValue,
    filterValues,
    serviceTypeList,
    changeHandlerFilter,
    serviceFilterValue,
    setSortingNameOrderBy,
    exportDownload,
    setSortingTabType,

    setOptionsList,
    optionsList,
    operatorList,
    setOperatorList,
    showOprater,
    setShowOprater,
    setFilterOprater,
    filterOprater,
    setFilterValueOptions,
    filterValueOptions,
    setServiceTypeShow,
    serviceTypeShow,
    searchValueFilter,
    actionData,
    isSearching, 
    showdata
  } = props;
  const navigate = useNavigate();
     const dispatch = useDispatch()
  const { allUpcomingCount } = useSelector((state) => state.users);
  const { first_name, last_name, id } = useSelector((state) => state.user.user);

  const [active, setActive] = useState({});
  const [activeUser, setActiveUser] = useState();
  const [allClients, setAllClients] = useState([]);
  const [allMediums, setAllMediums] = useState([]);
  const [allAttendeesMedium, setAllAttendeesMedium] = useState([]);

  const [subsessionsList, setSubsessionsList] = useState([]);

  const [reschedeId, setReschedeId] = useState("");
  const [reschedeData, setReschedeData] = useState([]);

  const [appointmentInfo, setAppointmentInfo] = useState({});

  const [usersListMedium, setUsersListMedium] = useState([]);
  const [usersListClient, setUsersListClient] = useState([]);

  const [selectedIndex, setSelectedIndex] = useState("");
  const [attendeesList, setattendeesList] = useState([]);
  const [noshowFrom, setNoShowFrom] = useState('');
  const [noShowActive, setNoShowActive] = useState();
  const [filterValuesMain, setFilterValuesMain] = useState({
  screen_name: ""
});
const [operatorVal,SetOperatorVal] = useState("=");
const [filters, setFilters] = useState({ filterValues: { screen_name: ""}, operator: "" });
const filtersRef = useRef({ filterValues: {}, operator: "" });
const [isFilterDirty, setIsFilterDirty] = useState(true);
   const [reasons, setReasons] = useState([]);
    const [selectedReason, setSelectedReason] = useState("");
      const [isRefund, setIsRefund] = useState(0);
      // Refunding/waiving a specific attendee only patches this attendee's
      // entry inside the parent list's attendees[] — the NoshowBox modal
      // renders a separate `attendeesList` snapshot taken when it opened,
      // which that patch doesn't touch, so this tracks whether the in-flight
      // confirm targets an attendee so refreshScreen() can be triggered on
      // success (matching how the No Show/Remove attendee actions already
      // refresh via actionData()).
      const [isAttendeeAction, setIsAttendeeAction] = useState(false);
      const [selectedMedium, setSelectedMedium] = useState();
      const [backFillId, setBackFillId] = useState('');
      const [panelAppointment, setPanelAppointment] = useState(null);
      const [panelViewType, setPanelViewType] = useState('appointment');
useEffect(() => {
    fetchReasons();
  }, []);

  const fetchReasons = async () => {
    try {
      const data = await getAllCancellationReasons();
      if (data && data.data && data.data.data) {
        const formatted = data.data.data.map((item) => ({
          id: item.id,
          value: item.reason,
        }));
        setReasons(formatted.length ? formatted : [{ id: null, value: "" }]);
        console.log(formatted, "cancellation reasons");
      }
    } catch (error) {
      console.error("Error fetching reasons:", error);
    }
  };
  useEffect(() => {
    console.log(filterOprater,"filterOpraterfilterOprater",searchValue,"searchValuesearchValue");
    if (filterOprater && Object.keys(searchValue).length > 0) {
      const newValues = {
        filterValues: { ...searchValue },
        operator: filterOprater
      };

    console.log("NEW VALUES:", newValues);
      filtersRef.current = newValues; 
    }

    setUsersListMedium(
      upcomingAppointments.map((item) => {
        return {
          ...item,
          value: item.id,
          label: item.medium_name,
        };
      })
    );
    setUsersListClient(
      upcomingAppointments.map((item) => {
        return {
          ...item,
          value: item.id,
          label: item.client_name,
        };
      })
    );
    // !allMediums.length > 0 && getMediumList(data);
  }, [upcomingAppointments]);
  const regenerateZoom = (id) => {
    let body = {
      appointment_id: id,
    };
    regenerateZoomLink(body)
      .then((data) => {
        if (data.data.status) {
          toast.success("Zoom link regenerating in background!!", {
            position: "top-center",
          });
          const data = {
            page: 1,
            rowsPerPage: 25,
          };
          // getAllAppointmentsList(data, activeTab);
          showdata(0);
        } else {
          toast.error("Something went wrong", { position: "top-center" });
        }
      })
      .catch(() => { });
  };
  const resendZoom = (id) => {
    let body = {
      appointment_id: id,
    };
    resendZoomLink(body)
      .then((data) => {
        if (data.data.status) {
          toast.success("Meeting link email resent to medium and client!", {
            position: "top-center",
          });
        } else {
          toast.error("Something went wrong", { position: "top-center" });
        }
      })
      .catch(() => { });
  };
  const changeHandlerLocal = (e, type, id, appoinment) => {
    console.log(e.target.value, type, id, appoinment, "ajmnsdckjmn");
     setActive({ e: e, type: type, id: id , appoinment: appoinment });
    if(type ==3 && e.target.value != appoinment.client_id){
      setSelectedReason("");
      window.loadModal2("#ConfirmCancelupcomingmediumAll", "show");
    }else{
      window.loadModal2("#ConfirmCancelAdmin", "show");
    }
  };

  const cancelRequest = () => {
    window.loadModal2("#ConfirmCancelAdmin", "hide");
    window.loadModal2("#ConfirmRefundAppointment", "hide");
    window.loadModal2("#ConfirmCancelupcomingmediumAll", "hide");
     window.loadModal2("#ReasonCancelupcomingmedium", "hide");
     window.loadModal2("#CreateNewMediumAppointment", "hide");
    emptyAllSelectBox();
  };
  const confirmRequest = () => {
    let { e, type, id, appoinment } = active;

    if(type == 3 &&  (appoinment.is_extra_services == 1 || appoinment.session_type == "8")){
      window.loadModal2("#ConfirmRefundAppointment", "show");
            return;
    }else{
      changeHandler(e, type, id);
    }
   
  };
  const confirmRequestNew = () => {
   let { e, type, id , appoinment} = active;
    window.loadModal2("#ConfirmCancelupcomingmediumAll", "hide");
    console.log("appoinment", appoinment);


    // cancelGroupAppointment
    if(appoinment.session_type == 5){
    window.loadModal2("#ReasonCancelupcomingmedium", "show");
    }else if(appoinment.is_group_session == 1){
      cancelGroupAppointment(appoinment.id);
    }else{
      window.loadModal2("#ConfirmCancelAdmin", "show");
    }
  }
  const confirmRequestReason =() => {
    let { e, type, id , appoinment} = active;
     changeHandler(e, type, id,selectedReason);
  }
  const openConfirmAppointment = () => {
    window.loadModal2("#ConfirmAppointment", "show");
  };
  const confirmAppointment = () => {
    confirmAppointmentstatus(activeUser.appointmentId)
      .then((data) => {
        if (data.data.status) {
          toast.success("Status Confirmed", { position: "top-center" });
          const data = {
            page: 1,
            rowsPerPage: 25,
          };
          getAllAppointmentsList(data, activeTab);
        } else {
          toast.error("Something went wrong", { position: "top-center" });
        }
      })
      .catch(() => { });
  };
  const getAllFreeClients = (data) => {
    getAllClients(data)
      // getAllClients("outreach")
      .then((data) => {
        if (data.data.status) {
          setAllClients(data.data.data.data);
          // dispatch(setAllOutreachClientsCount(data.data.data.total));

          // dispatch(setAllClients(data.data.data.data));
          // setbackupClients(JSON.parse(JSON.stringify(data.data.data.data)));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getMediumList = (item) => {
    getAllMediums(item)
      .then((data) => {
        if (data.data.status) {
          setAllMediums(data.data.data.data);
          // dispatch(setAllMediumsCount(data.data.data.total))
          // dispatch(setAllMediums(data.data.data.data));
          // setbackupMediums(JSON.parse(JSON.stringify(data.data.data.data)));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getMediumAttendees = (item) => {
     getAllMediums(item)
      .then((data) => {
        if (data.data.status) {
          setAllAttendeesMedium(data.data.data.data);
          // dispatch(setAllMediumsCount(data.data.data.total))
          // dispatch(setAllMediums(data.data.data.data));
          // setbackupMediums(JSON.parse(JSON.stringify(data.data.data.data)));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  
  const getSubsessions = (id) => {
    getCreateAppointmentSubseesions(id)
      .then((data) => {
        if (data.data.status) {
          setSubsessionsList(data.data.data);
        }
      })
      .catch(() => { });
  };
  const openReSchedulePopUp = (item, index) => {

    // setAppointmentInfo

    getAdminRescheduleSlots(item.id)
      .then((data) => {
        setReschedeData(data.data.data);
        setReschedeId(item);
        setSelectedIndex(index);
        window.loadModal2("#ReScheduleAppt", "show");
      })
      .catch(() => { });
  };
  const getTimeDiff = (appoinment) => {
    let now = moment().format();
    let datetimeB = moment(appoinment.createdDate);
    // console.log(appoinment.date,appoinment.time, "now",now)
    // console.log(datetimeB,"datetimeB")
    // var a = moment('2016-06-06T21:03:55');//now
    // var b = moment('2016-05-06T20:03:55');

    let final = datetimeB.diff(now, "minutes");
    // console.log(final)
    let status;
    final < -10 ? (status = true) : (status = false);
    return status;
  };

  const refreshScreen = () => {
    const data = {
      page: 1,
      rowsPerPage: 25,
    };
    getAllAppointmentsList(data, activeTab, "refresh");
  };
  const openNoShowBox = (list, from, item) => {
    setNoShowActive(item);
    setNoShowFrom(from);
    setattendeesList(list)
    window.loadModal('#NoshowBox', 'show');
  }
  const openWorkerBox = (list, from, item) => {
    setNoShowActive(item);
    setNoShowFrom(from);
    setattendeesList(list)
    window.loadModal('#WorkerBox', 'show');
  }
  const cancelGroupAppointment = (id) => {
    let body = {
      appointment_id: id
    }
    cancelGroupAppointments(body).then((data) => {
      if (data.data.status) {
        toast.success("Status updated succesfully", {
          position: "top-center",
        });
        const data = {
          page: 1,
          rowsPerPage: 25,
        };
       // getAllAppointmentsList(data, activeTab,);
       actionData(activeTab);
      }
      else {
        toast.error("Something went wrong", { position: "top-center" });
      }
    })
  }
  const noshowGroupAppointment = (item) => {
    console.log(item);
    let body = {
      appointment_id: noShowActive.id,
      user_id: item.user_id
    }
    noshowGroupAppointments(body).then((data) => {
      if (data.data.status) {
        toast.success("Status updated succesfully", {
          position: "top-center",
        });
        const data = {
          page: 1,
          rowsPerPage: 25,
        };
       // getAllAppointmentsList(data, activeTab,);
       actionData(activeTab);
      }
      else {
        toast.error("Something went wrong", { position: "top-center" });
      }
    })
  }
  const noshowRemoveGroupAppointment = (item) => {
    console.log(item);
    let body = {
      appointment_id: noShowActive.id,
      user_id: item.user_id
    }
    noshowRemoveGroupAppointments(body).then((data) => {
      if (data.data.status) {
        toast.success("Status updated succesfully", {
          position: "top-center",
        });
        const data = {
          page: 1,
          rowsPerPage: 25,
        };
       // getAllAppointmentsList(data, activeTab,);
       actionData(activeTab);
      }
      else {
        toast.error("Something went wrong", { position: "top-center" });
      }
    })
  }
  let info = JSON.parse(localStorage.getItem('paginationAppointment'))
  const navigateEdit = (e, id) => {
    window.renderFirst = false
    if (e.target.className == "capitalizeMedium") {
      navigate(`/profile-edit/${id.medium_id}?&searchURL=appointments&view=0&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info !== null ? info.page : 1}&rowperpage=${info !== null ? info.rowsPerPage : 25}&serviceFilterValue=${encodeURIComponent(JSON.stringify(serviceFilterValue))}&searchFilterOprater=${filterOprater}`);
    }
    if (e.target.className == "capitalize") {
      if (id.client_user_type === 3) {
        navigate(`/edit/${id.client_id}?&searchURL=appointments&view=0&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info !== null ? info.page : 1}&rowperpage=${info !== null ? info.rowsPerPage : 25}&serviceFilterValue=${encodeURIComponent(JSON.stringify(serviceFilterValue))}&searchFilterOprater=${filterOprater}`);
      } else {
        navigate(`/profile-edit/${id.client_id}?&searchURL=appointments&view=0&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info !== null ? info.page : 1}&rowperpage=${info !== null ? info.rowsPerPage : 25}&serviceFilterValue=${encodeURIComponent(JSON.stringify(serviceFilterValue))}&searchFilterOprater=${filterOprater}`);
      }
    }
  };
  const checkAppId = (appoinment) => {
    if (appoinment.is_group_session === 0) {
      return appoinment.id
    }
    else if (appoinment.is_group_session === 1) {
      if (appoinment.attendees == undefined) {
        if (appoinment.parent_id == null) {
          return appoinment.id
        }
        else {
          return appoinment.parent_id
        }

      }
      else {
        return appoinment.id
      }

    }
    else {
      return appoinment.id
    }

  }

  const handleSessionClick = (e, appoinment, columnType = 'appointment') => {
    if (e.target.closest && e.target.closest('button, a, input, select, textarea, [role="button"], .toggle-button-cover')) {
      return;
    }
    e.stopPropagation();
    if (columnType === 'medium' && !appoinment.medium_details) {
      columnType = 'appointment';
    }
    if (columnType === 'client' && !appoinment.client_details) {
      columnType = 'appointment';
    }
    setPanelViewType(columnType);
    setPanelAppointment(Object.assign({}, appoinment, {
      sessionIdDisplay: session_id_beg + checkAppId(appoinment) + session_id_end,
    }));
  };

  const createString = () => {

    let string = `screen_name=${searchValue !== undefined
        ? searchValue.screen_name !== undefined
          ? searchValue.screen_name
          : ""
        : ""}&session_type=${searchValue !== undefined
          ? searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : ""}&session_id=${searchValue !== undefined
            ? searchValueFilter.session_id !== undefined
              ? searchValueFilter.session_id
              : ""
            : ""}&name=${searchValue !== undefined
        ? searchValue.name !== undefined
          ? searchValue.name
          : ""
        : ""}&medium_email=${searchValue !== undefined
        ? searchValue.medium_email !== undefined
          ? searchValue.medium_email
          : ""
        : ""}&client_email=${searchValue !== undefined
        ? searchValue.client_email !== undefined
          ? searchValue.client_email
          : ""
        : ""}&meeting_id=${searchValue !== undefined
        ? searchValue.meeting_id !== undefined
          ? searchValue.meeting_id
          : ""
        : ""}&created_at=${searchValue !== undefined && searchValue.created_at !== undefined ? searchValue.created_at : ''}&session_date=${searchValue !== undefined && searchValue.session_date !== undefined ? searchValue.session_date : ''}&oprater=${filterOprater !== undefined ? filterOprater : ""}&country=${searchValue !== undefined && searchValue.country !== undefined ? searchValue.country : ""}
      `
    return string;
  }
  const exportData =()=>{
     let info = {
            appoitment_type: "upcoming", appoitment_value: 0,queryString: createString()
        }
    ExportData(info).then((data) => {
            if (data.data.status) {
                toast.success(data.data.message, { position: "top-center" });
            }
            }).catch(() => { })
  }



  const exportAllData = () => {
    // Saare data export WITHOUT filters
    let info = {
      appoitment_type: "upcoming", 
      appoitment_value: 0,
      queryString: "" // EMPTY - no filters
    }
    ExportData(info).then((data) => {
      if (data.data.status) {
        toast.success("All data exported successfully", { position: "top-center" });
      }
    }).catch(() => { })
  }


  const fliterdata = (name, oprater) => {
  const newValues = {
    filterValues: { ...name },
    operator: oprater
  };
console.log("NEW VALUES:", newValues);
  filtersRef.current = newValues; // <--- instant update (no delay)
  setFilters(newValues);
  setIsFilterDirty(false);          // UI update (async, but that's fine)
};


const LoadData = () => {
  // optional: clear old UI result before new search
  console.log("FILTERS USED:", filtersRef.current.filterValues, filtersRef.current.operator);


// setUpcomingAppointments([]);
  filterListAppointments(
    filtersRef.current.filterValues,
    filtersRef.current.operator
  );
  setIsFilterDirty(true);
};
const handleNoShow = (e, appoinment) => {
  let value = e.target.value;
    let noShowBy = value;
    setBackFillId(appoinment.id)
    setSelectedMedium(appoinment.medium_id)
    if(value === "refund"){
      setIsRefund(1);
      setIsAttendeeAction(false);
      window.loadModal2("#ConfirmRefundAppointmentFeedback", "show");
      //refundingCall(appoinment.medium_id, appoinment.id);
      return;
    }
     if(value === "stop_payment_request"){
      // stopPaymentCall(appoinment.medium_id, appoinment.id);
      setIsRefund(0);
      setIsAttendeeAction(false);
      window.loadModal2("#ConfirmRefundAppointmentFeedback", "show");
      return;
    }
}
 // Group sessions nest one row per attendee under appointment.attendees[],
 // each with its own transaction/payment_status; a refund/waive can target
 // either a top-level (1:1) row or one specific attendee's row, so this
 // patches whichever one matches appointmentId instead of assuming it's
 // always the top-level row.
 //
 // The host (whoever originally booked, parent_id null) appears TWICE in
 // the payload: once as the top-level row, and again as the last entry
 // inside its own attendees[] (see AppointmentRepository::
 // getAdminAllAppointments — `$res[$key]['attendees'][] = $val`). Refunding
 // the host matches appointment.id, but NoshowBox only ever reads
 // attendees[], so both copies must be patched — returning early after the
 // top-level match left the attendees[] copy stale, which is why the popup
 // kept showing "Paid" for the host attendee until reload.
 const patchPaymentStatus = (list, appointmentId, newStatus, extra = {}) =>
   list.map((appointment) => {
     let updated = appointment;

     if (appointment.id === appointmentId) {
       updated = { ...updated, payment_status: newStatus, ...extra };
     }

     if (Array.isArray(appointment.attendees)) {
       const attendeeIndex = appointment.attendees.findIndex(
         (attendee) => attendee.id === appointmentId
       );
       if (attendeeIndex !== -1) {
         const updatedAttendees = [...appointment.attendees];
         updatedAttendees[attendeeIndex] = {
           ...updatedAttendees[attendeeIndex],
           payment_status: newStatus,
           ...extra,
         };
         updated = { ...updated, attendees: updatedAttendees };
       }
     }

     return updated;
   });

 const refundingCall = (mediumId, appointmentId, isCancel=true) => {
    let body = {
      medium_id: mediumId,
      appointment_id: appointmentId
    }
   
      refundingAppointment(body)
      .then((data) => {
        emptyAllSelectBox()
        setTimeout(() => {
          dispatch(setLoadingText(false));
          dispatch(setLoadingContent(''));
        }, 1000);
        if (data.data.status) {
          // dispatch(setLoading(false))
          setUpcomingAppointments(prev =>
            patchPaymentStatus(prev, appointmentId, "Refunding")
          );

          // The patch above only updates the master list; the already-open
          // NoshowBox modal renders a separate `attendeesList` snapshot
          // taken when it opened, which that patch never touches — patch it
          // directly too, or the modal keeps showing "Paid" until the page
          // is reloaded.
          if (isAttendeeAction) {
            setIsAttendeeAction(false);
            setattendeesList(prev =>
              prev.map(attendee =>
                attendee.id === appointmentId
                  ? { ...attendee, payment_status: "Refunding" }
                  : attendee
              )
            );
          }

          // Shown for both the plain refund and the no-show + refund flow: either way
          // the refund still has to be completed through the payment integration.
          setTimeout(() => {
            showRefundNotice(data);
          }, 1000);


        }
      })
      .catch(() => {
        dispatch(setLoadingText(false));
        dispatch(setLoadingContent(''));
      });
  }

  const stopPaymentCall = (mediumId, appointmentId) => {
    let body = {
      medium_id: mediumId,
      appointment_id: appointmentId
    }
   
      stopPaymentAppointment(body)
      .then((data) => {
        emptyAllSelectBox()
        setTimeout(() => {
          dispatch(setLoadingText(false));
          dispatch(setLoadingContent(''));
        }, 1000);
        if (data.data.status) {
          // dispatch(setLoading(false))

setUpcomingAppointments(prev =>
          patchPaymentStatus(prev, appointmentId, "Waived")
        );

          setTimeout(() => {

              //no show
              toast.success("Status Updated Successfully", {
                position: "top-center",
              });


          }, 1000);


        }
        else {

      // ✅ THIS will show "Transaction not found"
      toast.error(data.data.message || "Something went wrong", {
        position: "top-center",
      });

    }
      })
      .catch(() => {
        dispatch(setLoadingText(false));
        dispatch(setLoadingContent(''));
      //    toast.error("Something went wrong", {
      //   position: "top-center",
      // });
      });
  }
   const confirmRefundAppt = () => {
    window.loadModal2("#ConfirmRefundAppointment", "hide");
     let { e, type, id, appoinment } = active;
   
      changeHandler(e, type, id);
       refundingCall(appoinment.medium_id, appoinment.id, false);
      return;
   
    // confirmAppointment()
  
    
    // refundingCallUpcomming(appoinment.medium_id, appoinment.id);
  };
   const confirmRefundNoAppt = () => {
    window.loadModal2("#ConfirmRefundAppointment", "hide");
     let { e, type, id, appoinment } = active;
    changeHandler(e, type, id);
   
    
   
  };
  const confirmAppt = () => {
      if(isRefund){
        refundingCall(selectedMedium, backFillId,false);
      } else {
        stopPaymentCall(selectedMedium, backFillId,false);
      }
    }
     const confirmApptNo = () => {
      // goToMediumBackFill(backFillId, appType);
      // cancelRequest();
      if(isRefund){
        refundingCall(selectedMedium, backFillId,  true);
      } else {
        stopPaymentCall(selectedMedium, backFillId, true);
      }
    }
    // Refund for one attendee inside a group session's attendee list
    // (NoshowBox). No waive here: group sessions are pay-to-book, so
    // there's no outstanding/unpaid attendee state to waive.
    const refundAttendee = (item) => {
      setBackFillId(item.id);
      setSelectedMedium(item.medium_id);
      setIsRefund(1);
      setIsAttendeeAction(true);
      window.loadModal2("#ConfirmRefundAppointmentFeedback", "show");
    };

    const handleCreateAppointment = () => {
 window.loadModal2("#SelectAppointmentType", "show");
};
const handleTypeSelect = (type) => {
  console.log("Selected:", type);
  if (type === "client_to_medium") {
    window.loadModal2("#CreateNewAppointment", "show");
  } else if (type === "medium_to_medium") {
    window.loadModal2("#CreateNewMediumAppointment", "show");
  }


 
};
const isSearchDisabled =
  !filtersRef.current.filterValues ||
  Object.keys(filtersRef.current.filterValues).length === 0;

  return (
    <>
      <div className="table-box-medium admin-appoi admin-upcoming-app" style={{ overflow: "visible" }}>
        <div className="appt-table-scroll" style={{ overflowX: "scroll", width: "100%" }}>
        <table className="caseTable">
          <tbody>
            <tr className="dark">
              <th className="min-width-100">Session #</th>
              <th>
                {/* <input type="checkbox" id="one" />
                <label htmlFor="one"></label> */}
                Medium Name
              </th>
              <th>Attendees</th>
              <th>Client<br />Confirm</th>
              <th>
                <div className="d-inline-flex align-items-center align-items-center">
                  <span>Date &amp; Time</span>
                  <Sorting tab={1} callApi={filterListAppointments} view={'admin'} types={'date'} setSortingNameOrderBy={setSortingNameOrderBy} setSortingTabType={setSortingTabType} />
                </div>
              </th>
              <th>Session Name</th>
              {/* <th>Emails</th> */}
              <th>Meeting Link</th>
              <th>Payment<br />Status</th>
              <th>Payment<br />Request</th>
              <th>Cancel</th>
              <th>No Show</th>
              <th><div className="d-inline-flex align-items-center align-items-center">
                <span> Created at</span>{" "}
                <Sorting tab={1} callApi={filterListAppointments} view={'admin'} types={'created_at'} setSortingNameOrderBy={setSortingNameOrderBy}
                  setSortingTabType={setSortingTabType} />
              </div></th>
            </tr>

             {isSearching ? (
     <tr>
    <td colSpan="12" className="text-center py-4">
      <div className="custom-loader">
        <div className="loader-dot"></div>
        <div className="loader-dot"></div>
        <div className="loader-dot"></div>
      </div>
      <div className="loader-text mt-2">Loading appointments...</div>
    </td>
  </tr>
    ) : upcomingAppointments.length > 0 ? (
    upcomingAppointments.map((appoinment, index) => (
                <tr onClick={(e) => handleSessionClick(e, appoinment)} className={`innr ${appoinment.is_worker_appointment == 1 ? "isWorkedBG" : "" }`} style={{ cursor: 'pointer' }}>
                  <td className="pointer" onClick={(e) => handleSessionClick(e, appoinment)}>

                    <div className="d-flex align-items-center">
                      <ImmediateSessionDot appointment={appoinment} /><div className="mr-1 mt-1"><CopyComponent value={session_id_beg + checkAppId(appoinment) + session_id_end} /></div> <div className="mt-1">{session_id_beg + checkAppId(appoinment) + session_id_end}</div>
                      {appoinment.give_add1_highlight ? <img className="ml-1 star-app-hightlight" src="../images/star.png" /> : ''}
                      <div className="mr-1 mt-1 ml-1">
                        {appoinment.backfill_code !== null ? <>
                          ({appoinment.backfill_code})
                        </> : <></>
                        }
                      </div>
                    </div>
                  </td>
                  <td className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalizeMedium' } }, appoinment); }}>
                    {/* <input type="checkbox" id="two" />
                    <label htmlFor="two"></label> */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      {appoinment.medium_profile_image ? (
                        <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalizeMedium' } }, appoinment); }} style={{ width: 36, height: 36, borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
                          <img width="100%" height="100%" style={{ objectFit: 'cover', display: 'block' }} src={process.env.REACT_APP_IMAGE_URL + appoinment.medium_profile_image} alt="" />
                        </div>
                      ) : (
                        <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalizeMedium' } }, appoinment); }} style={apptGetAvatarStyle(appoinment.medium_name)}>{apptGetInitials(appoinment.medium_name)}</div>
                      )}
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span className="capitalizeMedium" style={{ display: 'block' }}>{appoinment.medium_name} {(appoinment.medium_comment === true) && (<b style={{ fontSize: '22px' }}>*</b>)}</span>
                        <div style={{ color: '#666', fontSize: '13px', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                          {appoinment.medium_email} <CopyComponent value={appoinment.medium_email} />
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize' } }, appoinment); }}>
                    <div>
                      {appoinment.is_group_session !== 1 ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          {appoinment.client_profile_image ? (
                            <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize' } }, appoinment); }} style={{ width: 36, height: 36, borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
                              <img width="100%" height="100%" style={{ objectFit: 'cover', display: 'block' }} src={process.env.REACT_APP_IMAGE_URL + appoinment.client_profile_image} alt="" />
                            </div>
                          ) : (
                            <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize' } }, appoinment); }} style={apptGetAvatarStyle(appoinment.client_name)}>{apptGetInitials(appoinment.client_name)}</div>
                          )}
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span className="capitalize" style={{ display: 'block' }}>
                              {appoinment.client_name}
                              {appoinment.client_comment === true && (
                                <b style={{ fontSize: "22px" }}>*</b>
                              )}
                            </span>
                            <div style={{ color: '#666', fontSize: '13px', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                              {appoinment.client_email} <CopyComponent value={appoinment.client_email} />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          {appoinment &&
 Array.isArray(appoinment.attendees) &&
 appoinment.attendees.length > 0 && (
                            <span
                              className="text-underline pointer p-1"
                              onClick={(e) => {
                                e.stopPropagation();
                                openNoShowBox(appoinment.attendees, "remove", appoinment);
                              }}
                            >
                              {appoinment.noOfAttendees.length}&nbsp;Attendee(s)
                            </span>
                          )}

                          {appoinment &&
Array.isArray(appoinment.attendees) &&
 appoinment.attendees.length > 0 &&
                          Array.isArray(appoinment.workers) && appoinment.workers.length > 0 && <br />}

                          {appoinment && Array.isArray(appoinment.workers) && appoinment.workers.length > 0 && (
                            <span
                              className="text-underline pointer p-1"
                              onClick={(e) => {
                                e.stopPropagation();
                                openWorkerBox(appoinment.workers, "remove", appoinment);
                              }}
                            >
                              {appoinment.noOfWorkers.length}&nbsp;Worker(s)
                            </span>
                          )}

                          {!((appoinment.attendees && appoinment.attendees.length > 0) ||
                            (appoinment.workers && appoinment.workers.length > 0)) && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                              {appoinment.client_profile_image ? (
                                <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize' } }, appoinment); }} style={{ width: 36, height: 36, borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
                                  <img width="100%" height="100%" style={{ objectFit: 'cover', display: 'block' }} src={process.env.REACT_APP_IMAGE_URL + appoinment.client_profile_image} alt="" />
                                </div>
                              ) : (
                                <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize' } }, appoinment); }} style={apptGetAvatarStyle(appoinment.client_name)}>{apptGetInitials(appoinment.client_name)}</div>
                              )}
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <span className="capitalize">
                                  {appoinment.client_name}
                                  {appoinment.client_comment === true && (
                                    <b style={{ fontSize: "22px" }}>*</b>
                                  )}
                                </span>
                                <div style={{ color: '#666', fontSize: '13px', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                  {appoinment.client_email} <CopyComponent value={appoinment.client_email} />
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </td>
                  <td>
                    <div className="min-width-70px ">
                      <Toggle
                        openConfirmAppointment={openConfirmAppointment}
                        item={appoinment}
                        setActiveUser={setActiveUser}
                      />
                    </div>
                  </td>
                  <td>
                    <div style={{ fontWeight: '500' }}>{appoinment.date}</div>
                    <div style={{ color: '#666', fontSize: '13px', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                      {appoinment.time}
                      {appoinment.session_name !== "Donated - 30 Min Mediumship Session" && appoinment.is_group_session !== 1 ? (
                        <img src="images/icon-feather-edit.png" onClick={(e) => { e.stopPropagation(); openReSchedulePopUp(appoinment, index); }} title="Reschedule this appointment" className="pointer" style={{ width: '18px', height: '16px' }} />
                      ) : ("")}
                    </div>
                  </td>
                  <td className="width-190px ">{appoinment.guest_booking == 1 ? (<b style={{
                          fontSize: '22px',
                        }}>*</b>) : ""}{appoinment.session_name}</td>
{/* Emails column hidden */}
                  {getTimeDiff(appoinment)}
                  <td className="googl-link min-width-210">
                    {appoinment.meeting_link === "" ||
                      appoinment.meeting_link === null ||
                      appoinment.meeting_link === "NULL" ? (
                      getTimeDiff(appoinment) ? (
                        <>
                          <Button
                            className={`resend-btn w-unset height-35 min-width-130px`}
                            title="Regenerate"
                            status={0}
                            onClick={() => regenerateZoom(appoinment.id)}
                          />
                        </>
                      ) : (
                        <>
                          <span className="w-unset loading-regenrate">
                            {"Generating Zoom link"}
                          </span>

                          <img
                            title="Refresh"
                            onClick={(e) => refreshScreen("refresh")}
                            className="googl-link-copy-img copy-image-animate refresh-btn-app mt-4"
                            alt="copy"
                            src="images/refresh.png"
                          />
                        </>
                      )
                    ) : (
                      <>
                        <a href={appoinment.meeting_link} target={"_blank"} >
                          {appoinment.meeting_link.substring(0, 20).concat("...")}
                        </a>
                        <CopyComponent value={appoinment.meeting_link} />
                      </>
                    )}
                    {/* <a
                      target={"_blank"}
                      className={`d-flex align-items-center justify-content-center resend-btn new-btn-click-here height-35 min-width-130px`}
                      href={appoinment.meeting_link}
                    >
                      Click Here
                    </a> */}
                    {/* <a
                      className="appointment-links"
                      href={appoinment.meeting_link}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {appoinment.meeting_link}
                    </a>
                    <img
                      onClick={() => copyMeetingLink(appoinment.meeting_link)}
                      className="googl-link-copy-img "
                      src="images/copy.png"
                      alt="copy"
                    /> */}
                  </td>
                  <td>
                    {appoinment.attendees == undefined && appoinment.subsession_table_id != 102 ?

                      <div className={`${appoinment.payment_status != null ? "color-d5a67b" : ""} d-flex align-items-center height-45`}>
                        {appoinment.payment_status != null && appoinment.payment_status != "NULL" ? (appoinment.payment_status) : 'N/A'}
                      </div>
                      :
                      'N/A'
                    }
                  </td>
                  <td>
                    {appoinment.attendees == undefined ?
                      <>
                        {appoinment.is_group_session === 0 && (appoinment.session_type === "8" || appoinment.session_type === "7" || appoinment.is_extra_services == 1) ?
                          <select
                            // value={appoinment.statusValue}
                            onChange={(e) => handleNoShow(e, appoinment)}
                            className="appointment-select-box"
                          >
                            <option value="" selected disabled>
                              Select
                            </option>
                              {((appoinment.session_type === "8" || appoinment.is_extra_services == 1) && appoinment.payment_status != "Refunding") && (
                              <>
                              
                              <option value={"refund"}>{"Refunding"}</option>
                              </>
                            )}
                            {(appoinment.session_type === "7" && appoinment.payment_status != "Refunding" && appoinment.payment_status != "Waived" )&& (
                              <option
                                value={
                                  appoinment.payment_status === "Paid"
                                    ? "refund"
                                    : "stop_payment_request"
                                }
                              >
                                {appoinment.payment_status === "Paid"
                                  ? "Refunding"
                                  : "Stop Payment Request"}
                              </option>
                            )}


                            
                         
                          </select>
                          :
                          'N/A'
                        }
                      </>
                      :

                      'N/A'
                    }
                  </td>
                  <td>
                    {appoinment.is_group_session !== 1 ?
                      <select
                        onChange={
                          (e) =>
                            changeHandlerLocal(e, 3, appoinment.appointmentId,appoinment,"cancel")
                          // changeHandler(e, 3, appoinment.appointmentId)
                        }
                        // value={appoinment.statusValue}
                        className="appointment-select-box"
                      >
                        <option value="" selected disabled>
                          Select
                        </option>
                        {Object.entries(appoinment.userArray).map((show) => (
                          <option value={show[0]}>{show[1]}</option>
                        ))}
                        <option value={id}>{screenNameHandler(first_name, last_name)}</option>
                      </select>
                      :
                      <>
                        <Button
                          status={0}
                          onClick={(e) =>  changeHandlerLocal(e, 3, appoinment.appointmentId,appoinment,"cancel") }
                          type="button"
                          className={`resend-btn w-130`}
                          title="Cancel All"
                        />
                      </>
                    }
                  </td>
                  <td>
                    {appoinment.is_group_session !== 1 ?

                      <select
                        // value={appoinment.nostatusValue}
                        onChange={
                          (e) =>
                            changeHandlerLocal(e, 2, appoinment.appointmentId,appoinment)
                          // changeHandler(e, 2, appoinment.appointmentId)
                        }
                        className="appointment-select-box"
                      >
                        <option value="" selected disabled>
                          Select
                        </option>
                        {Object.entries(appoinment.userArray).map((show) => (
                          <option value={show[0]}>{show[1]}</option>
                        ))}
                      </select>
                      :
                      <>
                        <Button
                          status={0}
                          onClick={() => openNoShowBox(appoinment.attendees, '', appoinment)}
                          type="button"
                          className={`resend-btn w-130`}
                          title="No Show"
                        />
                      </>

                    }
                  </td>
                  <td>
                    {appoinment.createdDate ? (
                      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.5' }}>
                        <span>{appoinment.createdDate.split(',')[0]}</span>
                        <span style={{ color: '#888', fontSize: '12px' }}>{(appoinment.createdDate.split(',')[1] || '').trim()}</span>
                      </div>
                    ) : ''}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={20} style={{ padding: '48px 0', textAlign: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="8" r="4" stroke="#d5a67b" strokeWidth="1.5"/>
                      <path d="M4 20c0-4 3.582-7 8-7s8 3 8 7" stroke="#d5a67b" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                    <p style={{ margin: 0, fontSize: '15px', fontWeight: '600', color: '#485257' }}>No Appointments Found</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {/* <div className="pagination-box">
          <div className="left-pagi">
            <span>Showing 1 to 10 of 18 entries</span>
          </div>
          <div className="right-pagi">
            <ul>
              <li>Previous</li>
              <li className="active">
                <a href="#">1</a>
              </li>
              <li>
                <a href="#">2</a>
              </li>
              <li>
                <a href="#">3</a>
              </li>
              <li>Next</li>
            </ul>
          </div>
        </div> */}
        </div>
        <Pagination
          rowsPerPageOptions={[25, 50, 100]}
          count={allUpcomingCount}
          activeTab={"upcomingAdmin"}
          getPaginationData={getPaginationData}
          upcomingAppointmentsPage={upcomingAppointmentsPage}
          upcomingAppointmentsrowsPerPage={upcomingAppointmentsrowsPerPage}
        />
        <ConfirmCancel
          deleteUser={confirmRequest}
          cancelRequest={cancelRequest}
          id={"ConfirmCancelAdmin"}
        />
        <ReasonCancel
                  deleteUser={confirmRequestReason}
                  cancelRequest={cancelRequest}
                  reasons={reasons}                  // pass data as prop
                selectedReason={selectedReason}    // pass selected value
                setSelectedReason={setSelectedReason}
                  id={"ReasonCancelupcomingmedium"}
                />
        <ConfirmCancelNotePopup
          deleteUser={confirmRequestNew}
          cancelRequest={cancelRequest}
          active={active}
          id={"ConfirmCancelupcomingmediumAll"}
        />
        <ConfirmDeleteModal
          deleteUser={confirmAppointment}
          id={"ConfirmAppointment"}
          label={"Are you sure ?"}
          btnLabel={"Continue"}
        />
        {/* SelectAppointmentType / CreateNewAppointment / CreateNewMediumAppointment
            modals now live in ../index.js so the button works on every tab */}

        <NoshowBox
          noShowActive={noShowActive}
          list={attendeesList}
          refundAttendee={refundAttendee}
          noShowRequest={noshowGroupAppointment}
          noshowRemoveGroupAppointment={noshowRemoveGroupAppointment}
          noshowFrom={noshowFrom}
        />
         <WorkerBox
          noShowActive={noShowActive}
          list={attendeesList}
          noShowRequest={noshowGroupAppointment}
          noshowRemoveGroupAppointment={noshowRemoveGroupAppointment}
          noshowFrom={noshowFrom}
        />
         <RefundDeleteModal
                  deleteUser={confirmRefundAppt}
                  cancelRequest={confirmRefundNoAppt}
                  id={"ConfirmRefundAppointment"}
                  label={"Will a refund be issued for this cancellation?"}
                  btnLabel={"Continue"}
                />
                <RefundDeleteModal
                            deleteUser={confirmAppt}
                            cancelRequest={confirmApptNo}
                            id={"ConfirmRefundAppointmentFeedback"}
                            label={"Should client still receive feedback survey?"}
                            btnLabel={"Continue"}
                          />
      </div>
      <ReScheduleAppointment
        // usersListMedium={usersListMedium}
        // usersListClient={usersListClient}
        reschedeId={reschedeId}
        reschedeData={reschedeData}
        getAllAppointmentsList={getAllAppointmentsList}
        activeTab={activeTab}
        setReschedeId={setReschedeId}
        setReschedeData={setReschedeData}
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
      />
      <AppointmentInfoPanel
        appointment={panelAppointment}
        viewType={panelViewType}
        onClose={() => setPanelAppointment(null)}
        clientLabel="Attendee"
        onMediumClick={(appt) => navigateEdit({ target: { className: 'capitalizeMedium' } }, appt)}
        onClientClick={(appt) => navigateEdit({ target: { className: 'capitalize' } }, appt)}
        actions={[
          { label: 'Regenerate Zoom Link', variant: 'primary', onClick: () => { regenerateZoom(panelAppointment.id); setPanelAppointment(null); } },
          { label: 'Resend Zoom Link', variant: 'default', onClick: () => { resendZoom(panelAppointment.id); setPanelAppointment(null); } },
        ]}
      />
    </>
  );
}
